// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "clipboard" + "." + "abcd2fb802ed1b4183a0" + ".js";
};